// product.js

(function () {
  /**
   * 指定要素が出現するまで待つ
   */
  function waitForElement(selector, callback, timeout = 15000) {
    const el = document.querySelector(selector);

    if (el) {
      callback(el);
      return;
    }

    const observer = new MutationObserver(function () {
      const el = document.querySelector(selector);

      if (el) {
        observer.disconnect();
        callback(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, timeout);
  }

  /**
   * 指定条件がtrueになるまで待つ
   */
  function waitForCondition(conditionFn, callback, timeout = 15000) {
    if (conditionFn()) {
      callback();
      return;
    }

    const observer = new MutationObserver(function () {
      if (conditionFn()) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, timeout);
  }

  /**
   * レビューバッジ位置調整
   */
  function adjustReviewBadgePosition() {
    const $price = $(".p-prdDet-expTxt__price");
    const $badges = $('[id^="shopify-block-judge_me_reviews_preview_badge_"]');

    if (!$price.length || !$badges.length) return;

    const pricePos = $price.position().top;
    const priceHeight = $price.outerHeight();

    $badges.each(function () {
      const $badge = $(this);
      const starHeight = $badge.outerHeight();

      if (!starHeight) return;

      $badge.css(
        "top",
        `calc(${pricePos}px + (${priceHeight}px - .5rem) / 2 - (${starHeight}px / 2))`
      );
    });
  }

  /**
   * Judge.me レビュー投稿フォーム調整
   */
  function initJudgeMeFormCustomize() {
    $(document)
      .off("click.customJudgeMe", ".jdgm-write-rev-link")
      .on("click.customJudgeMe", ".jdgm-write-rev-link", function () {
        setTimeout(function () {
          $("input").each(function () {
            const name = $(this).attr("name");

            if (name === "review_title") {
              $(this).parent().css("display", "none");
            }

            if (name === "reviewer_name" || name === "reviewer_email") {
              $(this).parent().addClass("input-resize");
            }
          });

          $("textarea").each(function () {
            if ($(this).attr("name") === "review_body") {
              $(this).parent().addClass("input-resize2");
            }
          });
        }, 300);
      });
  }

  /**
   * レビュー日付表記変更
   */
  function formatReviewDates() {
    $(".jdgm-rev__timestamp").each(function () {
      const $el = $(this);

      if ($el.data("formatted")) return;

      const dataContent = $el.attr("data-content");
      if (!dataContent) return;

      const originalDate = dataContent.split(" ")[0];
      const parts = originalDate.split("-");

      if (parts.length !== 3) return;

      const year = parts[0];
      const month = String(parts[1]).padStart(2, "0");
      const day = String(parts[2]).padStart(2, "0");

      $el.text(`${year}/${month}/${day}`);
      $el.data("formatted", true);
    });
  }

  /**
   * ハッシュ付きアクセス時のスクロール
   */
  function initReviewHashScroll() {
    if (window.location.hash !== "#judgeme_product_reviews") return;

    waitForElement("#judgeme_product_reviews", function (targetElement) {
      setTimeout(function () {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: "smooth"
        });
      }, 300);
    });
  }

  /**
   * GPO要素のラップ
   */
  function wrapGpoContents() {
    const $naireContents = $(
      ".gpo-naire-select, .gpo-naire-txt, .gpo-naire-aside, .gpo-naire-attention"
    );

    const $giftContents = $(
      ".gpo-gift-ttl, .gpo-gift-attention, .gpo-gift-card-ttl, .gpo-gift-card, .gpo-gift-value, .gpo-gift-bag"
    );

    if ($naireContents.length && !$naireContents.first().parent().hasClass("gpo-contents")) {
      $naireContents.wrapAll("<div class='gpo-contents naire'></div>");
    }

    if ($giftContents.length && !$giftContents.first().parent().hasClass("gpo-contents")) {
      $giftContents.wrapAll("<div class='gpo-contents gift'></div>");
    }
  }

  /**
   * 名入れポップアップ
   */
  function initNairePopup() {
    $(document)
      .off("click.customNaire", ".gpo-naire-attention")
      .on("click.customNaire", ".gpo-naire-attention", function () {
        $(".p-product-naire__popup").addClass("active");
      });

    $(document)
      .off("click.customNaireClose", ".p-product-naire__popup-close, .p-product-naire__popup-overlay")
      .on("click.customNaireClose", ".p-product-naire__popup-close, .p-product-naire__popup-overlay", function () {
        $(".p-product-naire__popup").removeClass("active");
      });
  }

  /**
   * ギフトカード選択UI
   */
  function initGiftCardToggle() {
  $(document)
    .off("click.customGift", ".gpo-gift-card-ttl")
    .on("click.customGift", ".gpo-gift-card-ttl", function () {
      $(".gpo-gift-card").fadeToggle();
      $(".gpo-overlay").fadeToggle();
    });

  $(document)
    .off("click.customGiftOverlay", ".gpo-overlay")
    .on("click.customGiftOverlay", ".gpo-overlay", function () {
      $(".gpo-gift-card").fadeToggle();
      $(".gpo-overlay").fadeToggle();
    });

  $(document)
    .off("change.customGiftSwatch", ".gpo-swatches.image-swatches input[type='radio']")
    .on("change.customGiftSwatch", ".gpo-swatches.image-swatches input[type='radio']", function () {
      const $input = $(this);
      const value = $input.val();

      const $label = $input.next("label");
      const price = $label.find(".gpo-gift-card-price").data("price");

      const displayText = price && Number(price) !== 0
        ? `${value}　${price}円`
        : `${value}`;

      $(".gpo-gift-card-ttl").find("h6").text(displayText);

      $(".gpo-gift-card").fadeOut();
      $(".gpo-overlay").fadeOut();
    });
}

  /**
   * GPO ギフトカード価格表示
   */
  function addGiftCardPriceLabels() {
  if (!window.GPOConfigs || !window.GPOConfigs.options) return;

  const optionConfig = window.GPOConfigs.options[521055];
  if (!optionConfig || !optionConfig.elements) return;

  const gpoElements = optionConfig.elements;

  for (const element of gpoElements) {
    if (element.class_name !== "gpo-gift-card") continue;

    const optionValues = element.option_values || [];

    for (const option of optionValues) {
      const value = option.value;
      let price = option.variant_price;

      if (!price) {
        price = 0;
      }

      const $valueInput = $(`input[value="${escapeSelectorString(value)}"]`);
      if (!$valueInput.length) continue;

      const $cardLabel = $valueInput.next("label");

      if (!$cardLabel.length) continue;
      if ($cardLabel.find(".gpo-gift-card-price").length) continue;

      const priceTxt = price && Number(price) !== 0
        ? `${value}<br>${price}円`
        : `${value}`;

      const priceLabel = document.createElement("div");
      priceLabel.className = "gpo-gift-card-price";
      priceLabel.dataset.price = price;
      priceLabel.innerHTML = priceTxt;

      $cardLabel.prepend(priceLabel);
    }

    break;
  }
}

  /**
   * GPO全体初期化
   */
  function initGpoCustomize() {
    wrapGpoContents();
    initNairePopup();
    initGiftCardToggle();
    addGiftCardPriceLabels();
  }

  /**
   * セレクタ用エスケープ
   */
  function escapeSelectorString(val) {
    if (window.CSS && CSS.escape) {
      return CSS.escape(val);
    }

    return String(val).replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, "\\$&");
  }

  /**
   * 初期実行
   */
  window.addEventListener("load", function () {
    // レビューバッジ位置調整
    waitForCondition(
      function () {
        return (
          $(".p-prdDet-expTxt__price").length &&
          $('[id^="shopify-block-judge_me_reviews_preview_badge_"]').length
        );
      },
      function () {
        adjustReviewBadgePosition();

        setTimeout(adjustReviewBadgePosition, 500);
        setTimeout(adjustReviewBadgePosition, 1000);
      }
    );

    // Judge.me関連
    initJudgeMeFormCustomize();

    waitForElement(".jdgm-rev__timestamp", function () {
      formatReviewDates();

      setTimeout(formatReviewDates, 500);
      setTimeout(formatReviewDates, 1000);
    });

    initReviewHashScroll();

    // GPO関連
    waitForCondition(
      function () {
        return (
          $(".gpo-naire-select, .gpo-gift-ttl, .gpo-gift-card").length ||
          (window.GPOConfigs && window.GPOConfigs.options)
        );
      },
      function () {
        initGpoCustomize();

        setTimeout(initGpoCustomize, 500);
        setTimeout(initGpoCustomize, 1000);
      }
    );
  });

  /**
   * リサイズ時にレビュー位置を再調整
   */
  window.addEventListener("resize", function () {
  adjustReviewBadgePosition();
});

let productJsRetryCount = 0;
let productJsScrollTimer = null;

function retryProductJsOnScroll() {
  if (productJsRetryCount >= 5) return;

  clearTimeout(productJsScrollTimer);

  productJsScrollTimer = setTimeout(function () {
    productJsRetryCount++;

    adjustReviewBadgePosition();
    formatReviewDates();
    initGpoCustomize();

    if (productJsRetryCount >= 5) {
      window.removeEventListener("scroll", retryProductJsOnScroll);
    }
  }, 200);
}

window.addEventListener("scroll", retryProductJsOnScroll, {
  passive: true
});
})();